/**
 * @file
 * Replaced Drupal cores ajax throbber(s), see: https://www.drupal.org/node/2974681
 *
 */
(function($, Drupal) {
  /**
   * Prepare the Ajax request before it is sent.
   *
   * @param {XMLHttpRequest} xmlhttprequest
   * @param {object} options
   * @param {object} options.extraData
   */
  Drupal.Ajax.prototype.beforeSend = function(xmlhttprequest, options) {
    // For forms without file inputs, the jQuery Form plugin serializes the
    // form values, and then calls jQuery's $.ajax() function, which invokes
    // this handler. In this circumstance, options.extraData is never used. For
    // forms with file inputs, the jQuery Form plugin uses the browser's normal
    // form submission mechanism, but captures the response in a hidden IFRAME.
    // In this circumstance, it calls this handler first, and then appends
    // hidden fields to the form to submit the values in options.extraData.
    // There is no simple way to know which submission mechanism will be used,
    // so we add to extraData regardless, and allow it to be ignored in the
    // former case.
    if (this.$form) {
      options.extraData = options.extraData || {};

      // Let the server know when the IFRAME submission mechanism is used. The
      // server can use this information to wrap the JSON response in a
      // TEXTAREA, as per http://jquery.malsup.com/form/#file-upload.
      options.extraData.ajax_iframe_upload = "1";

      // The triggering element is about to be disabled (see below), but if it
      // contains a value (e.g., a checkbox, textfield, select, etc.), ensure
      // that value is included in the submission. As per above, submissions
      // that use $.ajax() are already serialized prior to the element being
      // disabled, so this is only needed for IFRAME submissions.
      const v = $.fieldValue(this.element);
      if (v !== null) {
        options.extraData[this.element.name] = v;
      }
    }

    // Disable the element that received the change to prevent user interface
    // interaction while the Ajax request is in progress. ajax.ajaxing prevents
    // the element from triggering a new request, but does not prevent the user
    // from changing its value.
    $(this.element).prop("disabled", true);

    if (!this.progress || !this.progress.type) {
      return;
    }

    // Displays triple bar loading animation for views using the 'Load more'
    // pager plugin.
    if ($("[data-drupal-views-infinite-scroll-pager]").length) {
      this.progress.type = "throbber";
    }

    const progressIndicatorMethod = `setProgressIndicator${this.progress.type
      .slice(0, 1)
      .toUpperCase()}${this.progress.type.slice(1).toLowerCase()}`;
    if (
      progressIndicatorMethod in this &&
      typeof this[progressIndicatorMethod] === "function"
    ) {
      this[progressIndicatorMethod].call(this);
    }
  };

  Drupal.theme.ajaxProgressThrobber = () => {
    if ($("[data-drupal-views-infinite-scroll-pager]").length) {
      return `
    <div class="ajax-spinner ajax-spinner--inline triple-bar-loader">
      <div class="sr-only">${Drupal.t(
        "Loading&nbsp;&hellip;",
        {},
        { context: "Loading text for Drupal cores Ajax throbber (inline)" }
      )}
      </div>
    </div>`;
    }

    return `
    <div class="ajax-spinner ajax-spinner--inline revolving-circle">
      <div class="sr-only">${Drupal.t(
        "Loading&nbsp;&hellip;",
        {},
        { context: "Loading text for Drupal cores Ajax throbber (inline)" }
      )}
      </div>
    </div>`;
  };
})(jQuery, Drupal);
